module.exports = __webpack_public_path__ + "img/IMG Lanchonete.c14cb068.png";